import { Container, Flex, Stack } from "@mantine/core";
import i18n from "common/i18n";
import Breadcrumb from "components/common/Breadcrumb";
import LanguageChooser from "components/LanguageChooser";
// import News from "components/News";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import UserService from "services/UserService";
import QuickActions from "./QuickActions";

const userLanguageHandler = async () => {
  const data = await UserService.getUserLanguage();

  if (data.status === 200 && !!data.data.language)
    i18n.changeLanguage(data.data.language);
  else UserService.setUserLanguage(i18n.language);
};

const HomePage = () => {
  const { t } = useTranslation("news");

  useEffect(() => {
    userLanguageHandler();
  }, []);

  return (
    <div className="flex w-full h-full flex-col flex-1">
      <Breadcrumb text={t("pageTitle")} />
      <Container className="flex flex-col pt-[10px] flex-1 px-[10px] w-full">
        <Flex gap={20} direction={"column"} justify={"space-between"}>
          <Stack gap={10}>
            {/* <News /> */}
            <QuickActions />
          </Stack>
        </Flex>
        <div className="border w-full max-w-[430px] mt-auto mx-auto mb-10 border-gray-light">
          <LanguageChooser className="w-full" />
        </div>
      </Container>
    </div>
  );
};
export default HomePage;
